// extracted by css-extract-rspack-plugin
export default {"container":"container-K7y3DH","innerContainer":"innerContainer-_apHMD","icon":"icon-KTbvui","title":"title-JBSOJw"};